import { Box, Typography } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const WelcomeHeader = () => {
  return (
    <Box display='flex' p={2}
      sx={{
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',

      }}
    >
      <AccountCircleIcon fontSize="large" />
      <Typography alignSelf='center' ml={2} fontWeight="bold">
        Manage My Moves Team
      </Typography>
    </Box>
  );
}

export default WelcomeHeader;
